const STORAGE_KEY = "linkedscope:executive-report-jobs";

export const EXECUTIVE_REPORT_JOBS_CHANGED = "executive-report-jobs:changed";
export const EXECUTIVE_REPORT_JOB_COMPLETED = "executive-report-job:completed";

const readJobs = () => {
  try {
    const jobs = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(jobs) ? jobs : [];
  } catch {
    return [];
  }
};

const writeJobs = (jobs) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(jobs));
  window.dispatchEvent(new CustomEvent(EXECUTIVE_REPORT_JOBS_CHANGED));
};

export const getExecutiveReportJobs = (accountId) =>
  readJobs().filter((job) => String(job.accountId) === String(accountId));

export const trackExecutiveReportJob = ({ runId, subscriptionId, accountId }) => {
  const jobs = readJobs().filter((job) => String(job.runId) !== String(runId));
  jobs.push({ runId, subscriptionId, accountId, createdAt: Date.now() });
  writeJobs(jobs);
};

export const removeExecutiveReportJob = (runId) => {
  writeJobs(readJobs().filter((job) => String(job.runId) !== String(runId)));
};
